import { ArrowDownCircle, ArrowUpCircle, CalendarClock, Wallet } from "lucide-react";

import { CarregandoCards } from "@/components/carregando";

import { reais } from "../lib/formato";

function Cartao({ icone: Icone, rotulo, valor, dica, tom, destaque, e2e }) {
  const cores = { verde: "text-emerald-600 dark:text-emerald-400", vermelho: "text-red-600 dark:text-red-400", neutro: "" };
  return (
    <div className={`rounded-2xl border bg-card p-3 sm:p-5 min-w-0 ${destaque ? "ring-1 ring-primary/30 border-primary/40" : ""}`} data-e2e={e2e}>
      <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground"><Icone className="w-4 h-4" />{rotulo}</div>
      {/* Celular (25/10/2026): fonte menor abaixo de 640 px — "R$ 36.440,31" saía do card */}
      <p className={`mt-1.5 text-lg min-[420px]:text-xl sm:text-3xl font-black tabular-nums tracking-tight whitespace-nowrap ${cores[tom] || ""}`}>{valor}</p>
      {dica ? <p className="text-xs text-muted-foreground mt-1">{dica}</p> : null}
    </div>
  );
}

/** Os quatro números que respondem "vai ter dinheiro?" — sempre de hoje a +30 dias. */
export default function CardsFluxo({ dados, carregando }) {
  if (carregando && !dados) {
    // Carregamento com cards (25/10/2026): a peça compartilhada do painel
    return <CarregandoCards quantos={4} className="grid grid-cols-2 lg:grid-cols-4 gap-3" altura="h-[124px]" />;
  }
  const r = dados?.resumo || {};
  const temBase = !!dados?.saldo_base;
  const previsto = Number(r.saldo_previsto_30) || 0;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      <Cartao icone={Wallet} rotulo={temBase ? "Saldo hoje" : "Resultado até hoje"} valor={reais(r.saldo_hoje)} e2e="card-saldo-hoje"
        dica={temBase ? "O que já entrou menos o que já saiu" : "Desde o início do período — informe o saldo da conta para ver o saldo real"}
        tom={Number(r.saldo_hoje) < 0 ? "vermelho" : "neutro"} />
      <Cartao icone={ArrowUpCircle} rotulo="A receber em 30 dias" valor={reais(r.receber_30)} tom="verde" e2e="card-receber"
        dica="Vendas que a maquininha, o banco e o iFood ainda vão pagar, já sem taxa" />
      <Cartao icone={ArrowDownCircle} rotulo="A pagar em 30 dias" valor={reais(r.pagar_30)} tom="vermelho" e2e="card-pagar"
        dica={Number(r.vencidas) > 0 ? `${reais(r.vencidas)} já vencido` : "Despesas lançadas e ainda não pagas"} />
      <Cartao icone={CalendarClock} rotulo={temBase ? "Saldo previsto em 30 dias" : "Resultado previsto em 30 dias"} valor={reais(previsto)} destaque e2e="card-previsto"
        tom={previsto < 0 ? "vermelho" : "verde"} dica="Hoje + a receber − a pagar" />
    </div>
  );
}
